import React from "react";
import { useTranslation } from "react-i18next";
import { classNames } from "../../Utils";

const Badge = ({ title, type = "primary", className, icon: Icon, theme = null }) => {
  const { t } = useTranslation();

  let typeClasses;
  switch (type) {
    case "secondary":
      typeClasses = "bg-slate-100 text-slate-700";
      break;
    case "success":
      typeClasses = "bg-green-100 text-green-800";
      break;
    case "danger":
      typeClasses = "bg-red-100 text-red-800";
      break;
    case "alert":
      typeClasses = "bg-yellow-100 text-yellow-800";
      break;
    case "info":
      typeClasses = "bg-blue-100 text-blue-700";
      break;
    default:
      typeClasses = "bg-blue-100 text-blue-700";
      break;
  }

  const isPrimary = type === "primary" || !type;
  const inlineStyle =
    isPrimary && theme
      ? { backgroundColor: theme.primaryLight, color: theme.primary }
      : {};

  return (
    <span
      className={classNames(
        "inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium",
        inlineStyle.backgroundColor ? "" : typeClasses,
        className
      )}
      style={inlineStyle}
    >
      {Icon && <Icon className="h-3 w-3 mr-1" />}
      {t(title)}
    </span>
  );
};

export default Badge;
